export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.f35dbc53.eot";